const Config = {
  ENVIRONMENT_LOCAL: 'LOCAL',
  ENVIRONMENT_LOCAL_REDE: 'LOCAL_REDE',
  ENVIRONMENT_DEV: 'DEVELOP',
  ENVIRONMENT_HML: 'HOMOLOG',
  ENVIRONMENT_PRD: 'PRODUCTION',
  URL_API_LOCAL: 'https://localhost:21018',
  URL_API_LOCAL_REDE: 'https://201.131.68.178:21018',
  URL_API_DEV: 'https://primepainel.com:21018',
  URL_API_HML: 'https://primepainel.com:21018',
  URL_API_PRD: 'https://primepainel.com:21018',
  SYSTEMAUTH_LOCAL: 'CampanhaVendas',
  SYSTEMAUTH_LOCAL_REDE: 'CampanhaVendas',
  SYSTEMAUTH_DEV: 'CampanhaVendas',
  SYSTEMAUTH_HML: 'CampanhaVendas',
  SYSTEMAUTH_PRD: 'CampanhaVendas',
};

export default Config;
